export default "__VITE_ASSET__MndaBMnA__"